import { ReactNode } from 'react'
import styles from './HiddenButton.module.scss'

interface HiddenButtonProps {
  position: { top: string; left: string }
  height?: number
  width?: number
  onClick: () => void
  children?: ReactNode
}

const HiddenButton: React.FC<HiddenButtonProps> = ({
  position,
  children,
  height = 120,
  width = 90,
  onClick,
}) => {
  return (
    <div
      className={`${styles.hiddenButtonRoot}`}
      style={{
        top: position.top,
        left: position.left,
        minHeight: height,
        minWidth: width,
      }}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

export default HiddenButton
